import ListTypes from './01.list-types'
import PaginationTypes from './02.pagination-types'

export const {
  SimpleList,
} = ListTypes

export const {
  LoadMorePagination,
} = PaginationTypes